<template>
  <div class="view-tasklists assessment_landing">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin" />
        <div class="content-wrapper">
          <div class="container-wrapper center">
            <div>
              <h3 class="d-inline heading">Assessment: {{ assessment_title }}</h3>
            </div>
            <div class="heading-seperator"></div>
            <div class="margin-bottom-10"></div>
            <div v-show="loading" class="loading_show">
              <div class="spinner-border text-danger"></div>
            </div>
            <div class="preview-section">
              <div class="col-12 p-0 text-align-center" >
                <div class="col-12">
                  Assessment: <b>{{ assessment_title }}</b>
                </div>
                <div class="heading-seperator" style="margin: 5px; margin-bottom: 25px;"></div>
                <div class="landing-page-content" style="padding-left:5px; padding-right:5px; text-align: left;">
                  <span v-html="landingPageContent"></span>
                </div>

              </div>
              <div class="col-lg-12 padding-lr-5  text-align-center" style="padding-right: 0;">
                <button
                  v-on:click="redirectAssessmentQuestionPage()"
                  class="btn btn-red col-5 padding-lr-5"
                  style="height: 30px;border-radius: 20px; margin-top: 2px;font-weight: bold;">Begin Assessment</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';

export default {
        data() {
          return {
            assessmentId: '',
            assessmentAttemptId: '',
            masterAdmin: false,
            assessment_title: '',
            loading: false,
            admin: false,
            landingPageContent: '',
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            redirectAssessmentQuestionPage: function() {
              router.push('/assessment-question-answer/' + this.assessmentId + '/' + this.assessmentAttemptId);
            },
        },
        created() {
          this.assessmentId = this.$route.params.assessmentId;
          this.assessmentAttemptId = this.$route.params.assessmentAttemptId;
          var roles = store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          this.admin = false;
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          axios.get('/assessment-landing-page/' + this.assessmentId, {
          })
          .then(resp =>  {
            this.landingPageContent = resp.data.landingPageContent;
            this.assessment_title = resp.data.assessmentTitle;
          })
          .catch(function(error) {
            console.log(error);
          });

        },

}

</script>

<style scoped>
.preview-section {
  width: 85%;
  margin: 0 auto;
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px 25px;
}
.assessment_landing .content-wrapper {
  font-size: 16px;
}
</style>
<style>
.assessment_landing .content-wrapper p {
  margin-bottom: 25px !important;
}
.answer_scale {
  padding: 10px 20px 25px 30px;
  border: 1px solid #CCC;
  margin: 0;
  width: 40%;
  border-radius: 10px;
  font-family: 'bebas-neue-pro', sans-serif;
}
.answer-scale-heading {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 15px;
}
.answer-scale-text {
  font-size: 16px;
  text-align: left;  
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/assessment_landing_page.vue